<template>
  <div class="dialog-edu-info">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="460px" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose">
      <el-form ref="FormRef" label-position="top" label-width="80px" :rules="rules" :model="formData">
        <el-form-item label="毕业时间" prop="graduation_time">
          <el-date-picker v-model="formData.graduation_time" type="month" placeholder="毕业时间" format="yyyy-MM" value-format="yyyy-MM" :validate-event="false" />
        </el-form-item>
        <el-form-item label="毕业院校" prop="graduate_school">
          <el-input v-model="formData.graduate_school" placeholder="请输入学校名称" />
        </el-form-item>
        <el-form-item label="专业" prop="major">
          <el-input v-model="formData.major" placeholder="请输入专业名称" />
        </el-form-item>

        <el-form-item label="学历" prop="educational_background">
          <el-input v-model="formData.educational_background" placeholder="请输入学历" />
        </el-form-item>
        <el-form-item label="学位" prop="xuewei">
          <el-select v-model="formData.xuewei" placeholder="请选择学位">
            <el-option v-for="item in options.degree" :key="item.id" :label="item.title" :value="+item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="获得学位时间" prop="degree_time">
          <el-date-picker v-model="formData.degree_time" type="date" placeholder="毕业时间" format="yyyy-MM" value-format="yyyy-MM" :validate-event="false" />
        </el-form-item>
        <!-- <el-form-item label="学历证书扫描件" prop="educational_background_file">

        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button v-if="isAdd" type="primary" @click="submitAdd(FormRef)">确 定</el-button>
        <el-button v-else type="primary" @click="submitEdit(FormRef)">立即修改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import Store from '@/store'
const emit = defineEmits(['handleClose', 'submitAdd', 'submitEdit'])

const isAdd = ref(false)

const props = defineProps({
  visible: {
    required: true,
    type: Boolean,
    default: () => false
  },
  title: {
    type: String,
    default: () => '请输入标题'
  },
  data: {
    type: Object,
    default: () => {}
  }
})
/* 下拉选项 */
const options = computed(() => {
  return Store.state.common.UserPortalData
})

const dialogVisible = computed(() => {
  return props.visible
})
const title = computed(() => {
  return props.title
})

const handleClose = () => {
  emit('update:visible', false)
  formData.value = {}
  resetForm(FormRef.value)
}

const checked = ref(false)
watch(checked, val => {
  if (val) {
    formData.value.end_time = '至今'
  } else {
    formData.value.end_time = ''
    resetForm(FormRef.value)
  }
})

onMounted(() => {
  if (JSON.stringify(props.data) !== '{}') {
    formData.value = { ...props.data }
  } else {
    isAdd.value = true
  }
})

const formData = ref({})

const rules = ref({
  graduation_time: {
    required: true,
    message: '请选择毕业日期'
  },
  graduate_school: {
    required: true,
    message: '请输入学校名称',
    trigger: 'blur'
  },
  major: {
    required: true,
    message: '请输入专业名称',
    trigger: 'blur'
  },
  xuewei: {
    required: true,
    message: '请选择学位',
    trigger: 'change'
  },
  educational_background: {
    required: true,
    message: '请选择学历',
    trigger: 'change'
  }
})

const FormRef = ref()

function resetForm(FromEl) {
  FromEl.resetFields()
}

async function submitAdd(FormRef) {
  await FormRef.validate((valid, fields) => {
    if (valid) {
      const currData = formData.value
      emit('add', currData)
      handleClose()
    } else {
      console.log('error submit!', fields)
    }
  })
}
async function submitEdit(FormRef) {
  await FormRef.validate((valid, fields) => {
    if (valid) {
      const currDatas = JSON.parse(JSON.stringify(formData.value))
      emit('edit', currDatas)
      handleClose()
    } else {
      console.log('error submit!', fields)
    }
  })
}
</script>

<style lang="scss" scoped>
:deep(.el-dialog__header) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.09);
}
:deep(.el-dialog__footer) {
  border-top: 1px solid rgba(0, 0, 0, 0.09);
}
:deep(.el-dialog__body) {
  padding-top: 16px;
}
:deep(.el-form--label-top .el-form-item__label) {
  padding: 0;
}
:deep(.el-form-item) {
  margin-bottom: 14px;

  &:last-child {
    margin-bottom: 0;
  }
}
:deep(.el-form-item .el-select) {
  width: 100%;
}
</style>
